
























































import { Vue, Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { currentScoutingStore } from "@/store/typed";
import VAccordion from "@/components/VAccordion.vue";
import ScoutingPlaceItem from "@/components/ScoutingPlace/Item.vue";
import IsocronCable from "@/cables/isocronCable";
import ModelParserMixin from "@/mixins/ModelParser";
import PoiSearch from "@/components/ScoutingPlace/Search.vue";
import IsocronCollapsible from "@/components/Isocron/Collapsible.vue";

@Component({
  components: {
    VAccordion,
    ScoutingPlaceItem,
    PoiSearch,
    IsocronCollapsible,
  },
})
export default class ScoutingPlaceCollapsableList extends Mixins(
  ModelParserMixin
) {
  @Prop({ default: true }) readonly deletable!: boolean;
  @Prop({ default: false }) readonly searchable!: boolean;
  @Prop({ default: false }) readonly showLegend!: boolean;
  @Prop({ default: false }) readonly isOpened!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: true }) readonly canClose!: boolean;

  private importer: IsocronCable | null = null;

  private term = "";

  async load() {
    await currentScoutingStore.loadScoutingPlaces();
  }

  get scouting() {
    return currentScoutingStore.scouting;
  }

  get scoutingPlaces() {
    if (this.searchable) {
      return currentScoutingStore.scoutingPlaces.filter(
        (o) =>
          o.name.toLowerCase().includes(this.term.toLowerCase()) ||
          o.fullAddress.toLowerCase().includes(this.term.toLowerCase())
      );
    } else {
      return currentScoutingStore.scoutingPlaces;
    }
  }

  mounted() {
    this.initExporter();
  }

  initExporter() {
    if (this.importer) {
      this.importer.close();
    }
    this.importer = new IsocronCable();
    this.importer.onResponse = this.onImporterResponse;
    this.importer.open();
  }

  onImporterResponse(data: any) {
    const isocron = this.$parseModel(data);
    if (!isocron) {
      return;
    }
    const place = currentScoutingStore.scoutingPlaces.find(
      (o) => o.isocron?.id === isocron.id
    );

    if (place) {
      place.isocron = isocron;
      currentScoutingStore.saveScoutingPlaceOffline(place);
    }
  }
  onStatusChanged(closed: boolean) {
    this.$emit("status", closed);
  }

  get poiCount() {
    return currentScoutingStore.scoutingPlaces.length;
  }

  destroyed() {
    this.importer?.close();
  }
}
